import Grid from "@mui/material/Grid";
import DataField from "../../atoms/dataField";
import React, { FC, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { CONNECTION_TYPES } from "../../../constants/_pickerValues";
import { IFormField } from "../../shared/globalTypes";

interface Props {
  selectedConnection: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  accountKey: IFormField;
  accountName: IFormField;
}

const ConnectionEXTSpoke: FC<Props> = ({
  selectedConnection,
  onChange,
  accountKey,
  accountName,
}: Props) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    selectedConnection === CONNECTION_TYPES.extSpoke
      ? setVisible(true)
      : setVisible(false);
  }, [selectedConnection]);

  if (visible) {
    return (
      <Box
        sx={{ border: 1, borderColor: "divider", padding: 3, width: "100%" }}
      >
        <h2>{selectedConnection}</h2>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <DataField id="319a4c20-5dcb-42bd-add1-5926a3a8fbe4"
              label="Account Key"
              name="accountKey"
              type="text"
              required={true}
              onChange={onChange}
              value={accountKey.fieldValue}
              error={accountKey.isError}
            />
          </Grid>
          <Grid item xs={4}>
            <DataField id="f038630a-5e58-4297-a603-5d9950460928"
              label="Account Name"
              name="accountName"
              type="text"
              required={true}
              onChange={onChange}
              value={accountName.fieldValue}
              error={accountName.isError}
            />
          </Grid>
        </Grid>
      </Box>
    );
  } else {
    return <></>;
  }
};

export default ConnectionEXTSpoke;
